<app-cargando *ngIf="cargando"></app-cargando>

<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{titulo}}</h4>

  <button type="button" class="close" aria-label="Close" (click)="activeModal.close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body user-edit-form">

  <div class="row">
    <div class="col-md-6">
      <label class="form-label">RUT</label>
      <input type="text" [(ngModel)]="data.RUT" name="RUT" class="form-control" placeholder="12.345.678-9">
    </div>
    <div class="col-md-6">
      <label class="form-label">Nombre</label>
      <input type="text" [(ngModel)]="data.NOMBRE" name="NOMBRE" class="form-control" placeholder="Nombre y apellido">
    </div>
    <div class="col-md-6">
      <label class="form-label">Correo</label>
      <input type="email" [(ngModel)]="data.CORREO" name="CORREO" class="form-control" placeholder="usuario@dominio.com">
    </div>
    <div class="col-md-6">
      <label class="form-label">Cargo</label>
      <div class="input-group mb-2">
        <input type="text" [(ngModel)]="data.CARGO" name="CARGO" class="form-control" placeholder="Cargo del usuario">
        <button type="button" class="btn btn-outline-brand" data-toggle="modal" data-target="#exampleModal" title="Seleccionar categorías">
          <i class="fa fa-tags"></i>
        </button>
      </div>
      <small class="text-muted">Usa Categorías para rellenar rápidamente el cargo.</small>
    </div>

    <div class="col-md-6">
      <label class="form-label">Perfil</label>
      <select [(ngModel)]="data.PERFIL" name="PERFIL" class="form-control">
        <option [ngValue]="null" disabled>Selecciona perfil</option>
        <option *ngFor="let perfil of perfiles" [ngValue]="perfil._id">{{perfil.NOMBRE}}</option>
      </select>
    </div>

    <div class="col-md-6">
      <label class="form-label">Vendedor</label>
      <select [(ngModel)]="data.VENDEDOR" name="VENDEDOR" class="form-control">
        <option [ngValue]="null" disabled>Selecciona vendedor</option>
        <option *ngFor="let vendedor of vendedores" [ngValue]="vendedor.SlpCode">{{vendedor.SlpName}}</option>
      </select>
    </div>

    <div class="col-md-6">
      <label class="form-label">Bodega default</label>
      <select [(ngModel)]="data.BODEGA_DEFAULT" name="BODEGA_DEFAULT" class="form-control">
        <option [ngValue]="null" disabled>Selecciona bodega</option>
        <option [ngValue]="">Sin Bodega</option>
        <option *ngFor="let b of bodegas" [ngValue]="b.WhsCode">{{b.WhsName}}</option>
      </select>
      <small class="text-muted">Se usará por defecto al crear documentos.</small>
    </div>

    <div class="col-md-6 d-flex align-items-end">
      <div class="w-100">
        <div class="check-grid">
          <div class="check-item">
            <input class="check-input" type="checkbox" id="chkMultiBodega" [(ngModel)]="data.MULTI_BODEGA" name="MULTI_BODEGA">
            <label class="check-tile" for="chkMultiBodega">Multi-bodega</label>
          </div>
        </div>
        <small class="text-muted">Permite seleccionar bodegas en la venta.</small>
      </div>
    </div>

    <div class="col-md-12" *ngIf="data.MULTI_BODEGA" style="margin-top:8px;">
      <div class="card" style="background:#1e293b; border:1px solid #334155; padding:12px;">
        <div class="check-grid" style="margin-bottom:8px;">
          <div class="check-item">
            <input class="check-input" type="checkbox" id="chkTodasBodegas" [(ngModel)]="data.BODEGAS_TODAS" name="BODEGAS_TODAS">
            <label class="check-tile" for="chkTodasBodegas">Todas las bodegas</label>
          </div>
        </div>
        <div *ngIf="!data.BODEGAS_TODAS">
          <small class="text-muted d-block mb-1">Selecciona las bodegas permitidas:</small>
          <div style="max-height:160px; overflow-y:auto; border:1px solid #475569; border-radius:4px; padding:6px;">
            <div *ngFor="let b of bodegas" style="padding:2px 0;">
              <label style="cursor:pointer; margin:0; display:flex; align-items:center; gap:6px;">
                <input type="checkbox" [checked]="isBodegaPermitida(b.WhsCode)" (change)="toggleBodegaPermitida(b.WhsCode)">
                <span>{{b.WhsCode}} — {{b.WhsName}}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6" style="margin-top: 8px;">
      <label class="form-label">Terminal Transbank default</label>
      <select [(ngModel)]="data.TERMINAL_TRANSBANK_DEFAULT" name="TERMINAL_TRANSBANK_DEFAULT" class="form-control">
        <option [ngValue]="null" disabled>Selecciona terminal</option>
        <option [ngValue]="''">Sin terminal asignado</option>
        <option *ngFor="let t of terminalesTransbank" [ngValue]="t._id">
          {{t.nombre}} - {{t.sucursal}} ({{t.ambiente}})
        </option>
      </select>
      <small class="text-muted">Se preseleccionará automáticamente en el cobro Smart POS.</small>
    </div>

    <div class="col-md-3">
      <label class="form-label">Color</label>
      <input type="color" [(ngModel)]="data.COLOR" name="COLOR" class="form-control" title="Color identificador">
    </div>
    <div class="col-md-9 d-flex align-items-end">
      <div class="w-100">
        <label class="form-label d-block">Permisos</label>
        <div class="check-grid">
          <div class="check-item">
            <input class="check-input" type="checkbox" id="chkActivo" [(ngModel)]="data.ACTIVO" name="ACTIVO">
            <label class="check-tile" for="chkActivo">Activo</label>
          </div>
          <div class="check-item">
            <input class="check-input" type="checkbox" id="chkAdmin" [(ngModel)]="data.ADMIN">
            <label class="check-tile" for="chkAdmin">Admin</label>
          </div>
          <div class="check-item">
            <input class="check-input" type="checkbox" id="chkOitm" [(ngModel)]="data.OITM_SAP">
            <label class="check-tile" for="chkOitm">PM con permisos SAP</label>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <label class="form-label" for="exampleInputFile">Foto</label>
      <div class="d-flex align-items-center" style="gap:8px;">
        <img [src]="data.IMAGE_LITTLE" class="img-fluid rounded" style="max-height: 64px; margin-right:8px;" />
        <div class="input-group">
          <div class="custom-file">
            <input type="file" class="custom-file-input" id="exampleInputFile" (change)="fileChangeEvent($event)">
            <label class="custom-file-label" for="exampleInputFile">Seleccionar imagen</label>
          </div>
        </div>
        <a class="btn btn-outline-danger" (click)="removeImage()" *ngIf="isImageSaved" title="Eliminar imagen"><i class='fa fa-trash'></i></a>
      </div>
      <div class="text-danger small mt-1">{{imageError}}</div>
    </div>

    <div class="col-12 text-center">
      <button type="button" class="btn btn-brand" data-toggle="modal" data-target="#exampleModalLong" style="color: white;">
        Restablecer contraseña
      </button>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Actualizar contraseña</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <input type="text" [(ngModel)]="data.PASSWORDNEW">
        </div>


        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
          <button (click)="recuperarPass()" type="button" class="btn btn-primary" data-dismiss="modal"
            style="background: #96D23A;color: #343A40;border: #96D23A;" data-dismiss="modal">Actualizar</button>
        </div>
      </div>
    </div>
  </div>





  <div class="form-group">
    <!--<input (click)="guardar();" class="btn btn-block btn-primary" value="Ingresar" />-->

  </div>


</div>
<div class="modal-footer">
  <!--<button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Save</button>-->

  <button (click)="guardar()" type="button" class="btn btn-primary w-100">{{txtButton}}</button>
</div>


<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content" style="background: #283F68;">

      <div class="modal-header" style="display: flex;justify-content: center;border-bottom: none;padding-bottom: 0px;">
        <h2 class="modal-title" id="exampleModalLabel">Categorías</h2>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" style="position: absolute;top: 10px;right: 10px;">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body" style="padding: 10px;">

        <ul class="categoria-list">
          
          <li *ngFor="let item of ItmsGrpNam" (click)="checkCategoria(item)">
            {{item.ItmsGrpNam}}
            <i class="fa-solid fa-check" *ngIf="item.checked"></i>
          </li>
        </ul>

      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" style="color: white;">Cerrar</button>
        <button type="button" class="btn btn-primary" style="color:#283F68;background: #96D23A;" data-dismiss="modal" (click)="guardar()">Actualizar</button>
      </div>
      
    </div>
  </div>
</div>